module.exports = "https://img.xiyuyouxi.com/saas/img/menu3.43ec3bc4.png";